module.exports = __webpack_public_path__ + "static/media/m-starRoad.5cb0ecc8.png";